// Menu - Inspections
import routeLocations from '../../../utility/route-locations';

const inspectMenuStructure = {
  groups: [{
    name: 'only_one',
    titleId: 'n/a',
    items: [
      {
        name: 'view-inspect',
        titleId: 'viewInspections',
        path: routeLocations.inspectionList,
        hidden: true,
      }, {
        name: 'single-inspect',
        titleId: 'viewInspections',
        path: routeLocations.inspection,
        hidden: true,
      },
    ],
  }],
};

export default inspectMenuStructure;
